(() => {
	function init() {
		// do stuff here
	}

	window.feUtils.waitForConditions({
		conditions: '#exitModal', // add page specific conditions here
		activity: feProjectId,
		callback: init,
	});
})();